import {InitialWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/initial/InitialWinPresentationController";
import {TweenLite} from "gsap";

/**
 * @description #132 => This class is used to add 1 sec. delay when reSpin is over.
 */
export class BFReSpinDelayController extends InitialWinPresentationController {

    /**
     * @inheritDoc
     * @param timeline
     */
    protected playWinAnimations(timeline:gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax):void {
        timeline.add(TweenLite.to(() => {}, 1, {}));
    }

    /**
     * @inheritDoc
     */
    protected hasWin():boolean {
        return (this._gameData!.mode.indexOf("RESPIN") !== -1);
    }

    protected addWinAnimationsToTimeline(timeline:gsap.Timeline) {
    }
}